"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRequired = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M7.415 2.006 8 3.814l-2.78.719L7.17 6.91 5.66 8 4 5.424 2.341 8 .83 6.91 2.78 4.533 0 3.814l.585-1.808L3.22 3.071 3.073 0h1.854L4.78 3.071l2.635-1.065Z", fill: "#C42137" }) }))); };
exports.default = SvgRequired;
